const midRouter = (store) => (next) => (action) => {
  next(action);
};

export default midRouter;
